import { observer } from 'mobx-react';
import React from 'react';
import TableToolbar from '../../shared/tableToolbar';
import IndustrySegmentsStore from './IndustrySegmentsStore';
import * as api from '../../../stores/api';

@observer
class IndustrySegmentsToolbar extends React.Component {
  handleSearchChange = (_, { value }) => {
    IndustrySegmentsStore.setFieldsValue({ keyword: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    IndustrySegmentsStore.refetch({}, true);
  };

  handleReset = () => {
    IndustrySegmentsStore.resetStore();
  };

  handleCreate = () => {
    return IndustrySegmentsStore.toggleModal(true, { modalType: 'addEdit' })();
  };

  render() {
    const { keyword, loading } = IndustrySegmentsStore;
    return (
      <TableToolbar.Container>
        <TableToolbar.Left onSubmit={this.handleSubmit}>
          <TableToolbar.Input
            placeholder="Search"
            value={keyword}
            onChange={this.handleSearchChange}
            disabled={loading}
          />
          <TableToolbar.SubmitButton disabled={loading}>Search</TableToolbar.SubmitButton>
          <TableToolbar.HighLightButton
            className="negative"
            disabled={loading}
            onClick={this.handleReset}
            style={{ marginLeft: '5px' }}
          >
            Clear
          </TableToolbar.HighLightButton>
        </TableToolbar.Left>
        <TableToolbar.Right>
          {api.isAdminOrMagStaffOrAccounting() && !api.isOnlySearch() && (
            <TableToolbar.HighLightButton className="positive" disabled={loading} onClick={this.handleCreate}>
              Add Industry Segment
            </TableToolbar.HighLightButton>
          )}
        </TableToolbar.Right>
      </TableToolbar.Container>
    );
  }
}

export default IndustrySegmentsToolbar;
